// extracted by mini-css-extract-plugin
module.exports = {"theme":"styles_theme__3Mbwt","fill":"styles_fill__fxdMG","stop1":"styles_stop1__RUB3j","stop2":"styles_stop2__1MjoM","stop3":"styles_stop3__2Cxss","stop4":"styles_stop4__2VBpz"};